namespace TabAurous.OMS {
    export interface VoucherMasterRow {
        VoucherTypeId?: number;
        VoucherTypeName?: string;
        TypeOfVoucher?: string;
        VoucherCode?: string;
        MethodOfVoucherNumbering?: string;
        IsTaxApplicable?: boolean;
        Narration?: string;
        AutoPosting?: boolean;
        IsDisabled?: boolean;
        IsDefault?: boolean;
        MasterId?: number;
        Declaration?: string;
        Terms?: string;
        Heading1?: string;
        Heading2?: string;
        Heading3?: string;
        Heading4?: string;
        MenuId?: number;
        StockUpdateMode?: string;
        AllowBackDatedEntry?: boolean;
        DefaultMetalDepartment?: number;
        DefaultStoneDepartment?: number;
        DefaultJewelleryDepartment?: number;
        DefaultOthersDepartment?: number;
        Details?: VoucherTaxDetailsRow[];
        MaterialType?: string;
        Separator?: string;
        Prefix?: string;
        PrefixDate?: string;
        Suffix?: string;
        Format?: string;
        IncrementBy?: number;
        LastNumber?: number;
        PrefillwithZero?: boolean;
        Noofzeroes?: number;
        BranchWise?: boolean;
        CounterWise?: boolean;
        Lock?: boolean;
        ResetMonthly?: boolean;
        ResetYearly?: boolean;
        Num1?: number;
        Num2?: number;
        Num3?: number;
        String1?: string;
        String2?: string;
        String3?: string;
        Sys_Date?: string;
        LedgerId?: number;
    }

    export namespace VoucherMasterRow {
        export const idProperty = 'VoucherTypeId';
        export const nameProperty = 'VoucherTypeName';
        export const localTextPrefix = 'OMS.VoucherMaster';
        export const lookupKey = 'VoucherMaster';

        export function getLookup(): Q.Lookup<VoucherMasterRow> {
            return Q.getLookup<VoucherMasterRow>('VoucherMaster');
        }
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = '*';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            VoucherTypeId = "VoucherTypeId",
            VoucherTypeName = "VoucherTypeName",
            TypeOfVoucher = "TypeOfVoucher",
            VoucherCode = "VoucherCode",
            MethodOfVoucherNumbering = "MethodOfVoucherNumbering",
            IsTaxApplicable = "IsTaxApplicable",
            Narration = "Narration",
            AutoPosting = "AutoPosting",
            IsDisabled = "IsDisabled",
            IsDefault = "IsDefault",
            MasterId = "MasterId",
            Declaration = "Declaration",
            Terms = "Terms",
            Heading1 = "Heading1",
            Heading2 = "Heading2",
            Heading3 = "Heading3",
            Heading4 = "Heading4",
            MenuId = "MenuId",
            StockUpdateMode = "StockUpdateMode",
            AllowBackDatedEntry = "AllowBackDatedEntry",
            DefaultMetalDepartment = "DefaultMetalDepartment",
            DefaultStoneDepartment = "DefaultStoneDepartment",
            DefaultJewelleryDepartment = "DefaultJewelleryDepartment",
            DefaultOthersDepartment = "DefaultOthersDepartment",
            Details = "Details",
            MaterialType = "MaterialType",
            Separator = "Separator",
            Prefix = "Prefix",
            PrefixDate = "PrefixDate",
            Suffix = "Suffix",
            Format = "Format",
            IncrementBy = "IncrementBy",
            LastNumber = "LastNumber",
            PrefillwithZero = "PrefillwithZero",
            Noofzeroes = "Noofzeroes",
            BranchWise = "BranchWise",
            CounterWise = "CounterWise",
            Lock = "Lock",
            ResetMonthly = "ResetMonthly",
            ResetYearly = "ResetYearly",
            Num1 = "Num1",
            Num2 = "Num2",
            Num3 = "Num3",
            String1 = "String1",
            String2 = "String2",
            String3 = "String3",
            Sys_Date = "Sys_Date",
            LedgerId = "LedgerId"
        }
    }
}
